import React from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import CustomLoader from "../../../../components/CustomLoader";
import HttpServices from "../../../../utils/Http.services";
import { checkTranslation, imageAddress, translate } from "../../../../utils/useful";
import EagleViewBanner from "../../../DeskViews/DeskNotifView";
import Monitor from "../../../DeskViews/Monitor";
import Responsive from "../../../../components/Responsive";
import ProductViewBox from "../../ProductViewBox";

export default class BookingUserViewServices extends Component {
    state = {
        services: []
    }

    componentDidMount = () => {
        this.fetchServices()
    }


    fetchServices() {
        let data = {}
        data.applet = this.props.applet._id
        data.appletHub = this.props.applet.hub._id
        this.setState({ isLoading: true })

        // console.log(data)

        HttpServices.request('getProducts', data, (fetchResult, fetchError) => {
            this.setState({ isLoading: false })

            // console.log('fetchError', fetchResult,fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                return
            }
            this.setState({ services: fetchResult.info })
        })
    }

    serviceClicked = (link) => {
        console.log('serviceClicked', link)
        // return
        let newLink = [...this.props.baseUrl,'service', link]
        this.props.changeWindow(newLink)
    }

    render() {



        return (
            <div className="h-100 w-100 scroll-no-scrollbar" >

                <button className='flexc p-3 w-100' style={{ backgroundColor: '#94257c10', }}>
                    <div className='br-20 flexcc mrd-2' style={{ color: '#fff', backgroundColor: '#94257c', minWidth: 20, height: 20 }}>
                        <p className='text-smaller text-semibold'>1</p>
                    </div>
                    <p className='text-small text-semibold' style={{ color: '#94257c' }}>You have one upcomming reservation in 2024/07/10 10:30</p>
                </button>


                <div className="w-100">
                    <div className="flexcc">
                        <div className="d-flex flex-wrap w-100 p-2">
                            {this.state.services.map((item, index) => {
                                return (
                                    <Responsive width={this.props.width} height={'100%'} media={{ xs: '12', 400: '6', 700: '3', lg: '3', xl: '2' }}>
                                        <ProductViewBox data={item} settings={{ baseUrl: [...this.props.baseUrl] }} onClick={this.serviceClicked} />
                                    </Responsive>
                                )
                            })}
                        </div>
                    </div>
                </div>
                {this.state.isLoading && (
                    <div className='mt-4'>
                        <div className='flexcc w-100 h-100'>
                            <CustomLoader isLoading={true} color={'#007aff'} height={18} width={18} />
                            <p className='mld-3'>{translate("Is Loading")}</p>
                        </div>
                    </div>
                )}
            </div >
        );
    }
}

